<template>
  <div>
    <label class="dbo-ui" for="">{{ title }}</label>
    <vue2Dropzone
      class="dropzone"
      ref="dropzone"
      v-model="dataForm.archives"
      id="dropzone"
      @vdropzone-removed-file="deleteFile"
      @vdropzone-file-added="filesUploaded"
      @vdropzone-success="handleComplete"
      :options="dropzoneOptions"
      :use-custom-slot="true"
    >
      <div class="dz-message text-muted" data-dz-message>
        <span class="font-28"><i class="fa fa-upload"></i></span>
        <p>
          Clique ou arraste os documentos para esta área<br />
          <small>pdf, doc, docx, xls, xslx, jpg, png, bmp</small>
        </p>
      </div>
    </vue2Dropzone>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "UploadData",
  props: {
    files: {
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    forceRedirect: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Adicione os documentos de sua empresa (Preenchimento Opcional)",
    },
    balanceType: {
      type: String,
      default: "BALANCE-2020",
    },
    autoProcessQueue: {
      type: Boolean,
      default: false,
    },
    alertRemove: {
      type: String,
      default: '',
    },
  },
  components: {
    vue2Dropzone,
  },
  created() {
    this.dropzoneOptions.autoProcessQueue = this.autoProcessQueue;
    if (this.alertRemove) {
      this.dropzoneOptions.dictRemoveFileConfirmation = this.alertRemove; 
    }
  },
  data() {
    let dataUpload = this.dataUpload();
    return {
      dataForm: {},
      urlForm: '',
      is_destroying: false,
      totalFiles: 1,
      uploadedFilesCount: 0,
      isDeleteFile: true,
      dropzoneOptions: {
        url: dataUpload.urlUpload,
        thumbnailWidth: 150,
        parallelUploads: 15,
        uploadMultiple: false,
        addRemoveLinks: true,
        autoProcessQueue: false,
        maxFilesize: 25,
        headers: { Authorization: dataUpload.token.access_token },
      },
    };
  },
  beforeDestroy() {
    this.is_destroying = true;
  },
  destroyed() {
    this.is_destroying = false;
  },
  methods: {
    filesUploaded() {
      if (this.forceRedirect) {
        this.totalFiles += this.$refs.dropzone.dropzone.getQueuedFiles().length;
        this.$emit("uploadFinished", this.balanceType);
      }
    },
    fillFiles(files) {
      files.forEach((item) => {
        this.$refs.dropzone.manuallyAddFile({ name: item.name, id: item.id }, "");
      });
    },
    deleteFile(file) {
      if (this.is_destroying) {
        return;
      }
      this.isDeleteFile ? this.$emit("deleteFile", file.id) : "";
    },
    dataUpload(url = null) {
      this.urlForm = url ? url : this.url;
      let urlUpload = process.env.VUE_APP_API_URL + this.urlForm;
      let token = JSON.parse(localStorage.getItem("token"));
      return {
        token,
        urlUpload,
      };
    },
    handleComplete() {
      this.uploadedFilesCount++;
      if (this.uploadedFilesCount == this.totalFiles) {
        this.clearUploadState();
        this.$emit("showEconomicGroupFiles", false);
        this.totalFiles = 1;
        this.uploadedFilesCount = 0;
      }
    },
    clearUploadState() {
      this.isDeleteFile = false;
      this.$refs.dropzone.dropzone.removeAllFiles(true);
      this.isDeleteFile = true;
    },
  },
  watch: {
    url(data) {
      var dataUpload = this.dataUpload(data);
      this.$set(this.$refs.dropzone.dropzone.options, "url", dataUpload.urlUpload);
    },
    files(data) {
      this.fillFiles(data);
    },
  },
};
</script>

<style></style>
